import { render, staticRenderFns } from "./overAllScoreDetail.vue?vue&type=template&id=a13aa5b0&scoped=true&"
import script from "./overAllScoreDetail.vue?vue&type=script&lang=js&"
export * from "./overAllScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./overAllScoreDetail.vue?vue&type=style&index=0&id=a13aa5b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13aa5b0",
  null
  
)

export default component.exports